var _path, _path2, _path3, _path4, _path5, _path6, _defs;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgGroup(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 69,
    height: 49,
    viewBox: "0 0 69 49",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.5 21C14.6421 21 18 17.866 18 14C18 10.134 14.6421 7 10.5 7C6.35786 7 3 10.134 3 14C3 17.866 6.35786 21 10.5 21Z",
    fill: "#214068"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M59 21C62.866 21 66 17.866 66 14C66 10.134 62.866 7 59 7C55.134 7 52 10.134 52 14C52 17.866 55.134 21 59 21Z",
    fill: "#214068"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M62.0067 25.0148H55.0134C53.0496 25.0148 51.3092 25.8311 50 26.9441C54.4706 29.1701 57.5361 33.2363 58.3025 38H65.5034C67.3555 38 69 36.5753 69 34.75V31.5C69 27.9532 65.8387 25 62.0067 25V25.0148Z",
    fill: "url(#paint0_linear_5944_64167)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M34.5 25C41.4036 25 47 19.4036 47 12.5C47 5.59644 41.4036 0 34.5 0C27.5964 0 22 5.59644 22 12.5C22 19.4036 27.5964 25 34.5 25Z",
    fill: "url(#paint1_linear_5944_64167)"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M43.0149 28H42.1142C39.7563 29.0884 37.1855 29.7447 34.5 29.7447C31.8145 29.7447 29.1291 29.0884 26.7711 28H25.8705C18.7148 28 13 33.6822 13 40.6928V43.75C13 46.7111 15.358 49 18.3709 49H50.6291C53.5438 49 56 46.6951 56 43.75V40.6928C56 33.6822 50.187 28 43.0149 28Z",
    fill: "url(#paint2_linear_5944_64167)"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M19 26.9292C17.683 25.8162 15.9324 25 14.0533 25H7.03466C3.08369 25 0 27.9384 0 31.5V34.75C0 36.5753 1.54184 38 3.51733 38H10.6484C11.4193 33.2363 14.4869 29.1701 19 26.9441V26.9292Z",
    fill: "url(#paint3_linear_5944_64167)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_5944_64167",
    x1: 67.5,
    y1: 38,
    x2: 28,
    y2: 17,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#214068"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#214068",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_5944_64167",
    x1: 34.5,
    y1: 0,
    x2: 34.5,
    y2: 25,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#406596"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#214068"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_5944_64167",
    x1: 34.5,
    y1: 28,
    x2: 34.5,
    y2: 49,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#345887"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#122B4A"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_5944_64167",
    x1: -2.14965e-7,
    y1: 36,
    x2: 56,
    y2: 21,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#214068"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#214068",
    stopOpacity: 0
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgGroup);
export default __webpack_public_path__ + "static/media/group.bdcd112232d1a35b81b8cf3d8a9ecdda.svg";
export { ForwardRef as ReactComponent };